var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98922 6.20595H1.32275V1.5M1.59436 14.0714C2.46402 15.4219 3.74011 16.4557 5.23529 17.0209C6.73044 17.5861 8.36631 17.6531 9.90205 17.2119C11.4377 16.7708 12.7923 15.8449 13.7677 14.57C14.743 13.2951 15.2876 11.7383 15.3211 10.1284C15.3545 8.51835 14.8752 6.94008 13.9537 5.62505C13.032 4.31002 11.7165 3.32779 10.2004 2.82217C8.68438 2.31655 7.04767 2.31412 5.53032 2.81574C4.01299 3.31735 2.69524 4.29623 1.77026 5.60882",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.a2ba997d19e2c8376147361d0f06b515.svg";
export { ForwardRef as ReactComponent };